import { useQuery as useApolloQuery } from '@apollo/client/react';
import { useOrganizationStore } from '../../../stores/useOrganizationStore';
import { GET_DASHBOARD_STATS } from '../../../lib/graphql/queries/organizations';
import type { GQLOrganizationStats } from './useOrganization';

interface DateRange {
  from: Date | null;
  to: Date | null;
}

export const useOrganizationStats = (dateRange?: DateRange) => {
  const { organization } = useOrganizationStore();
  const orgId = organization?.id;

  const dateFrom = dateRange?.from?.toISOString() ?? undefined;
  const dateTo = dateRange?.to?.toISOString() ?? undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, loading, error } = useApolloQuery<any>(GET_DASHBOARD_STATS, {
    variables: { organizationId: orgId ?? '', dateFrom, dateTo },
    skip: !orgId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    stats: (data?.organization?.stats ?? null) as GQLOrganizationStats | null,
    isLoading: loading,
    error,
  };
};
